export const ECOMMERCE = {
  OMNI_STORE: 'Omni',
};

export const EVENTS = {
  PRODUCT_VIEW: 'productView',
  CART_VIEW: 'cartView',
  CART_REMOVE: 'cartRemove',
  CART_ADD: 'cartAdd',
  CART_ADD_OPEN: 'cartAddOpen',
  CHECKOUT_START: 'checkoutStart',
  ERROR: 'errorMessage',
};

export const ANALYTICS_SOURCE_TYPES = {
  CART: 'cart',
  EBOOK_SEARCH_RESULT_ITEM: 'ebook-search-result-item',
  ERROR: 'error',
  FETCH_BASE_QUERY_ERROR: 'fetch-base-query-error',
  LOCALE: 'locale',
};

export const ANALYTICS_PAGE_TYPES = {
  SEARCH: 'search',
};

export const ANALYTICS_SUBPAGE_TYPES = {
  EBOOKS: 'ebooks',
};

export const ANALYTICS_MAX_ERROR_LENGTH = 500;
